export class TransactionState {
}
